import React from "react";
import "./SmartWrapper.scss";
interface props {
  children: React.ReactNode;
}

export const AdvanceWrapper = ({ children }: props) => {
  return (
    <div className="advanced-wrapper ">
      <div className="advanced-inner-wrapper">{children}</div>
    </div>
  );
};
